import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})

export class HomeService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web que obtiene los items del carrusel principal
   * Autor: Diego Diaz
   * @param category indica la sección desde la cual se llama el carrusel (home en este caso)
   * @return Listado de ítem de carrusel
   */
  getCarouselList(category) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_CAROUSEL_LIST,category);
  }

}
